import axios from '@/libs/axios'

export default {
  getChecklistDictionary: id => axios.get(`/vehicle/checklist-dictionary/${id}`),
  getChecklistDictionaries: query => axios.get('/vehicle/checklist-dictionary', { params: query }),
  getFreeChecklistDictionaries: () => axios.get('/vehicle/checklist-dictionary/find?freeOnly'),
  addChecklistDictionary: data => axios.post('/vehicle/checklist-dictionary', data),
  updateChecklistDictionary: (id, data) => axios.put(`/vehicle/checklist-dictionary/${id}`, data),
}
